import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {ProductBarcodeReportModel} from "./product-barcode-report.model";

@Component({
    selector: "wbo-product-barcode-report",
    templateUrl: "./product-barcode-report.component.html",
    providers: [provideReportModel(ProductBarcodeReportModel)]
})
export class ProductBarcodeReportComponent extends AbstractReportPage {
    constructor(public model: ProductBarcodeReportModel) {
        super();
    }
}
